import { rest } from 'msw'

import { getResponseObject } from '@webapp/tests'

export const mockGetApprovedExpenseItemCountSuccess = (count = 46) => {
  return rest.get('/api/v3/expenses/items/approved/', (req, res, ctx) => {
    // The count query requests page_size=1 — fall through to the list
    // handler for any other request against this endpoint
    if (req.url.searchParams.get('page_size') !== '1') return undefined

    return res(ctx.status(200), ctx.json(getResponseObject([], { count })))
  })
}
